import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-[#1e40af] text-white shadow hover:bg-[#1e3a8a]",
        destructive:
          "bg-[#ef4444] text-white shadow-sm hover:bg-[#dc2626]",
        outline:
          "border border-[#1e40af] bg-white text-[#1e40af] shadow-sm",
        secondary:
          "bg-[#f97316] text-white shadow-sm hover:bg-[#ea580c]",
        ghost: "text-[#1e40af] hover:bg-blue-50 hover:text-[#1e40af]",
        link: "text-[#1e40af] underline-offset-4 hover:underline",
        success: "bg-[#22c55e] text-white shadow hover:bg-[#16a34a]",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

// Outline: hover blu pieno solo se il chiamante non definisce un proprio hover/sfondo (evita testo bianco su sfondo chiaro)
const outlineHover = (className, style) =>
  /hover:(bg|text)-/.test(className || "") || style?.backgroundColor || style?.background
    ? ""
    : "hover:bg-[#1e40af] hover:text-white";

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  const extra = variant === "outline" ? outlineHover(className, props.style) : "";
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className: cn(extra, className) }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
